import { usePrincipalKey } from "@auth/sessionStore";
import { useParams } from "@tanstack/react-router";
import { useOpenVisits } from "@visits/visitsQueries";

interface ScreenContext {
  patientUuid?: string;
  visitUuid?: string;
  patientName?: string;
}

export const useScreenContext = (): ScreenContext => {
  const { patientId } = useParams({ strict: false });
  const { data: openVisits } = useOpenVisits(usePrincipalKey());
  if (!patientId) return {};
  const matches = (openVisits ?? []).filter((v) => v.patientId === patientId);
  if (matches.length !== 1) return { patientUuid: patientId };
  return {
    patientUuid: patientId,
    visitUuid: matches[0].id,
    patientName: matches[0].patientName,
  };
};
